<div class="pdm-form" [ngClass]="{'disabled-section': !sampleHandleService._isEditingModeEnabled()}">

    <!-- Product -->
    <section class="pdm-section">
        <div class="pdm-section__header">
            <h4 class="pdm-section__title">Product</h4>
            <p class="pdm-section__desc">Type, inventory item, and HS code for this sample.</p>
        </div>
        <div class="pdm-section__body">
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <div class="searchable-dropdown">
                    <select
                            id="productType"
                            class="input-M peer"
                            [(ngModel)]="selectedLabel"
                            (ngModelChange)="onLabelSelected($event)"
                            [disabled]="productSample().productSampleId !== undefined && productSample().productSampleId !== -1"
                    >
                        <option hidden value="-1">Select Type</option>
                        @for (label of getLabelTypes(); track label.id) {
                            <option [value]="label.id">{{ label.labelName }}</option>
                        }
                    </select>
                    <label for="productType" class="floating-c-lbl">Product Type<span class="text-red-700">*</span></label>
                </div>

                <div class="searchable-dropdown">
                    <select
                            id="Product"
                            class="input-M peer"
                            [(ngModel)]="selectedProduct"
                            (ngModelChange)="onProductSelected($event)"
                    >
                        <option hidden value="-1">Select Product</option>
                        @for (item of inventoryItemFindDTOS(); track item.inventoryId) {
                            <option [value]="item.inventoryId">{{ item.name }}</option>
                        } @empty {
                            <option hidden disabled>No Products Found</option>
                        }
                    </select>
                    <label for="Product" class="floating-c-lbl">Product<span class="text-red-700">*</span></label>
                </div>

                <div class="searchable-dropdown">
                    <select
                            id="psHsCode"
                            class="input-M peer"
                            [(ngModel)]="productSample().psHsCode"
                            (ngModelChange)="updateField('psHsCode', $event)"
                    >
                        <option hidden value="-1">Select HS Code</option>
                        @for (code of getHsCodes(); track code.hsCodeId) {
                            <option [value]="code.hsCodeId">{{ code.hsCode }}</option>
                        }
                        @empty {
                            <option hidden disabled>No HS Code Found</option>
                        }
                    </select>
                    <label for="psHsCode" class="floating-c-lbl">HS Code<span class="text-red-700">*</span></label>
                </div>
            </div>
        </div>
    </section>

    <!-- Sample -->
    <section class="pdm-section">
        <div class="pdm-section__header">
            <h4 class="pdm-section__title">Sample</h4>
            <p class="pdm-section__desc">Identification, quantity, and required date.</p>
        </div>
        <div class="pdm-section__body">
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
                <div class="relative">
                    <input type="text" id="sampleName" class="input-M peer w-full" placeholder=" "
                           [(ngModel)]="productSample().sampleName"
                           (ngModelChange)="updateField('sampleName', $event)"
                           name="sampleName">
                    <label class="label" for="sampleName">Sample Name <span class="text-red-700">*</span></label>
                </div>

                <div class="relative">
                    <input type="number" id="sampleQuantity" class="input-M peer w-full" placeholder=" "
                           [(ngModel)]="productSample().sampleQuantity"
                           positiveNumberOnly
                           selectOnClick
                           (ngModelChange)="updateField('sampleQuantity', $event)"
                           name="sampleQuantity">
                    <label class="label" for="sampleQuantity">Sample Quantity <span class="text-red-700">*</span></label>
                </div>

                <div class="relative">
                    <input id="requiredDate" type="date" class="peer w-full dateField" placeholder="Required Date"
                           [(ngModel)]="productSample().requiredDate"
                           [min]="today | date:'yyyy-MM-dd'"
                           (ngModelChange)="updateField('requiredDate', $event)">
                    <label class="label" for="requiredDate">Required Date <span class="text-red-700">*</span></label>
                </div>
            </div>

            <div class="relative">
                <input type="text" id="note" class="input-M peer w-full" placeholder=" "
                       [(ngModel)]="productSample().note"
                       (ngModelChange)="updateField('note', $event)"
                       name="note">
                <label class="label" for="note">Note</label>
            </div>
        </div>
    </section>

    <!-- Customer -->
    <section class="pdm-section">
        <div class="pdm-section__header">
            <h4 class="pdm-section__title">Customer &amp; Ownership</h4>
            <p class="pdm-section__desc">Customer, buyer, sales owner, and department.</p>
        </div>
        <div class="pdm-section__body">
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <div class="col-span-1 sm:col-span-2 lg:col-span-1">
                    <app-search-customer
                            [customerId]="productSample().customer"
                            [required]="false"
                            (selectedCustomerId)="onFieldSelected('customer', $event)">
                    </app-search-customer>
                </div>

                <div class="relative">
                    <input type="text" id="manualCustomer" class="input-M peer w-full" placeholder=" "
                           [(ngModel)]="productSample().manualCustomer"
                           (ngModelChange)="updateField('manualCustomer', $event)"
                           name="manualCustomer">
                    <label class="label" for="manualCustomer">Customer Name (Additional)</label>
                </div>

                <div class="col-span-1 sm:col-span-2 lg:col-span-1">
                    <app-search-sales-executive
                            [salesOwnerId]="productSample().sampleOwner"
                            [required]="true"
                            (selectedSalesOwnerId)="onFieldSelected('sampleOwner', $event)"
                            (salesOwnerStatus)="handleSalesOwnerStatus($event)">
                    </app-search-sales-executive>
                </div>

                <div class="col-span-1 sm:col-span-2 lg:col-span-1">
                    <div class="relative">
                        <input type="text" id="contactPerson" class="input-M peer w-full" placeholder=" "
                               [(ngModel)]="productSample().contactPerson"
                               (ngModelChange)="updateField('contactPerson', $event)"
                               name="contactPerson">
                        <label class="label" for="contactPerson">Contact Person</label>
                    </div>
                </div>

                <div class="col-span-1 sm:col-span-2 lg:col-span-1">
                    <app-search-buyer
                            [buyerId]="productSample().buyer"
                            (selectedBuyerId)="onFieldSelected('buyer', $event)">
                    </app-search-buyer>
                </div>

                <div class="col-span-1 sm:col-span-2 lg:col-span-1">
                    <app-search-department
                            [required]="false"
                            [departmentId]="productSample().department"
                            (selectedDepartment)="onFieldSelected('department', $event)">
                    </app-search-department>
                </div>
            </div>
        </div>
    </section>

    <!-- Finishings -->
    <section class="pdm-section">
        <div class="pdm-section__header">
            <div class="flex items-start justify-between gap-3 flex-wrap">
                <div>
                    <h4 class="pdm-section__title">Product Finishings</h4>
                    <p class="pdm-section__desc">Choose finishings, then set sequence, requirement, and remarks.</p>
                </div>
                @if (selectedFinishings().length > 0) {
                    <span class="pdm-badge">{{ selectedFinishings().length }} selected</span>
                }
            </div>
        </div>
        <div class="pdm-section__body pdm-section__body--compact">
            @if (productSample().department <= 0) {
                <p class="pdm-empty-hint">Select a product type or department to load available finishings.</p>
            } @else if (finishingsLoading()) {
                <p class="pdm-empty-hint">Loading finishings...</p>
            } @else if (departmentFinishings().length === 0) {
                <p class="pdm-empty-hint">No finishings available for this department.</p>
            } @else {
                <div class="pdm-finishings-layout">
                    <div class="pdm-finishings-available">
                        @for (group of departmentFinishings(); track group.type) {
                            <div class="pdm-finishing-group">
                                <h5 class="pdm-finishing-group__title">{{ formatFinishingType(group.type) }}</h5>
                                <div class="pdm-finishing-group__grid">
                                    @for (finishing of group.finishings; track finishing.id) {
                                        <label class="pdm-finishing-chip"
                                               [class.pdm-finishing-chip--selected]="isFinishingSelected(finishing.id)">
                                            <input type="checkbox"
                                                   class="pdm-checkbox"
                                                   [checked]="isFinishingSelected(finishing.id)"
                                                   (change)="onFinishingToggle(finishing.id, finishing.name, group.type, $event)">
                                            <span class="pdm-finishing-chip__label">{{ finishing.name }}</span>
                                        </label>
                                    }
                                </div>
                            </div>
                        }
                    </div>

                    @if (selectedFinishings().length > 0) {
                        <div class="pdm-finishings-selected">
                            <h6 class="pdm-finishings-selected__title">Selected finishings</h6>
                            <div class="pdm-table-wrap">
                                <table class="pdm-finishings-table">
                                    <thead>
                                    <tr>
                                        <th class="w-16">Sequence</th>
                                        <th>Finishing</th>
                                        <th class="w-24">Required</th>
                                        <th>Remarks</th>
                                        <th class="w-24 text-center">Order</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    @for (finishing of selectedFinishings(); track finishing.finishingId) {
                                        <tr>
                                            <td class="text-gray-600 font-medium">{{ finishing.sequence }}</td>
                                            <td>
                                                <span class="text-gray-900">{{ finishing.name }}</span>
                                                <span class="pdm-finishings-table__type">{{ formatFinishingType(finishing.type) }}</span>
                                            </td>
                                            <td>
                                                <input type="checkbox"
                                                       class="pdm-checkbox"
                                                       [checked]="finishing.isRequired"
                                                       (change)="onFinishingRequiredChange(finishing.finishingId, $any($event.target).checked)">
                                            </td>
                                            <td>
                                                <input type="text"
                                                       class="input-M w-full text-sm py-1"
                                                       placeholder="Optional note"
                                                       [ngModel]="finishing.remarks"
                                                       (ngModelChange)="onFinishingRemarksChange(finishing.finishingId, $event)">
                                            </td>
                                            <td>
                                                <div class="flex justify-center gap-1">
                                                    <button type="button"
                                                            class="pdm-order-btn"
                                                            title="Move up"
                                                            [disabled]="finishing.sequence === 1"
                                                            (click)="moveFinishing(finishing.finishingId, 'up')">
                                                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"/>
                                                        </svg>
                                                    </button>
                                                    <button type="button"
                                                            class="pdm-order-btn"
                                                            title="Move down"
                                                            [disabled]="finishing.sequence === selectedFinishings().length"
                                                            (click)="moveFinishing(finishing.finishingId, 'down')">
                                                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    </section>

    <!-- Options -->
    <section class="pdm-section">
        <div class="pdm-section__header">
            <h4 class="pdm-section__title">Options</h4>
        </div>
        <div class="pdm-section__body pdm-section__body--compact">
            <div class="pdm-options-list">
                <label class="pdm-option-row cursor-pointer" for="isOriginalSample">
                    <input type="checkbox" id="isOriginalSample"
                           class="pdm-checkbox"
                           [(ngModel)]="productSample().isOriginalSample"
                           (ngModelChange)="updateField('isOriginalSample', $event)">
                    <span class="text-sm text-gray-800">Original Sample</span>
                </label>

                <div class="pdm-fsc-option">
                    <div class="pdm-fsc-toggle">
                        <label class="pdm-option-row cursor-pointer" for="nonFsc">
                            <input type="radio"
                                   id="nonFsc"
                                   name="fscMode"
                                   class="pdm-radio"
                                   [checked]="!isFsc()"
                                   (change)="onFscModeChange(false)">
                            <span class="text-sm text-gray-800">Non FSC</span>
                        </label>
                        <label class="pdm-option-row cursor-pointer" for="isFsc">
                            <input type="radio"
                                   id="isFsc"
                                   name="fscMode"
                                   class="pdm-radio"
                                   [checked]="isFsc()"
                                   (change)="onFscModeChange(true)">
                            <span class="text-sm text-gray-800">FSC</span>
                        </label>
                    </div>

                    @if (isFsc()) {
                        <div class="pdm-fsc-certificates">
                            @if (certificatesLoading()) {
                                <p class="pdm-empty-hint">Loading FSC certificates...</p>
                            } @else if (fscCertificates().length === 0) {
                                <p class="pdm-empty-hint">No FSC certificates found</p>
                            } @else {
                                @for (certificate of fscCertificates(); track certificate.id) {
                                    <label class="pdm-finishing-chip"
                                           [class.pdm-finishing-chip--selected]="isCertificateSelected(certificate.id)">
                                        <input type="checkbox"
                                               class="pdm-checkbox"
                                               [checked]="isCertificateSelected(certificate.id)"
                                               (change)="onCertificateToggle(certificate.id, $event)">
                                        <span class="pdm-finishing-chip__label">{{ formatCertificateLabel(certificate) }}</span>
                                    </label>
                                }
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    </section>
</div>
